module.exports = __webpack_public_path__ + "static/media/01_atw_weihnachtskarte.5ad1736a.svg";